<script setup>
/******************************************************************************
 * Component: required hint in forms
 *****************************************************************************/
import SvgIcon from "Components/SvgIcon/SvgIcon.vue";
defineProps({
    top: {
        type: Number,
        default: 0,
    },
    bottom: {
        type: Number,
        default: 0,
    },
    additionalText: {
        type: String,
        default: "",
    },
});
</script>

<template>
    <div class="text-hint">
        <svg-icon name="info" />
        <span class="text">
            Felder mit einem <strong>*</strong> sind Pflichtfelder und müssen
            ausgefüllt werden.
            <span v-if="additionalText.length > 0">{{ additionalText }}</span>
        </span>
    </div>
</template>

<style lang="scss" scoped>
.text-hint {
    display: flex;
    align-items: center;

    max-width: get($breakpoints, "small");
    padding: #{get($sizes, "base") * 0.5};
    margin-top: calc(v-bind(top) * get($sizes, "base"));
    margin-bottom: calc(v-bind(bottom) * get($sizes, "base"));
    gap: #{get($sizes, "base") * 0.5};

    background-color: get($client, "formReqBg");
    color: get($client, "formReqColor");
    border-radius: get($sizes, "radius");

    @include respond-to("medium") {
        margin: calc(v-bind(top) * get($sizes, "base") * 2) 0
            calc(v-bind(bottom) * get($sizes, "base") * 2)
            calc(35% + #{get($sizes, "base")});
    }

    > .text > strong {
        color: get($client, "formReqStarColor");

        font-weight: 900;
    }
}
</style>
